jQuery(function($) {
  'use strict';

  $(document).ready(function() {
    $('.mdc-text-field__input, .mdc-select__native-control').change(function() {
      var value, labelElement;

      value = $(this).val();

      if (value !== '') {
        // Toevoegen van floating class zodat label omhoog bij het invullen door bijvoorbeel een password manager

        labelElement = $(this).closest('.ipo-mdc-form__field-container').find('.mdc-floating-label');
        if (labelElement.length > 0 && !labelElement.hasClass('mdc-floating-label--float-above')) {
          labelElement.addClass('mdc-floating-label--float-above');
        }
      }

      // Server side error message niet meer tonen na interactie vanuit gebruiker
      $(this).closest('.ipo-mdc-form').find('.ipo-mdc-form__error').html('');
    });
  });
});
